<template>
    <div class="event-feedback-cards-container">
        <div
            v-for="(review, indx) in reviews"
            :key="indx"
            :style="feedbackCardStyle"
            class="event-feedback-card-wrapper"
        >
            <div class="rating-info">
                <div class="info-wrapper">
                    <img
                        class="profile-image"
                        :src="
                            mode === 'Artist' ? review.profile_picture : review.venue_picture
                        "
                        alt="artist-avatar"
                    />
                    <div class="info">
                        <p class="user-type">{{ mode }}</p>
                        <p class="user-name">
                            {{ mode === 'Artist' ? review.user_name : review.venue_name }}
                        </p>
                    </div>
                </div>
                <div class="rating-wrapper">
                    <p class="title">Rate</p>
                    <div class="ratings">
                        <div v-for="(rating, indx) in ratingVals" :key="indx" class="rating">
                            <p class="rating-title">
                                {{ rating }}
                            </p>
                            <b-form-rating
                                v-model="review[ratingKeys[indx]]"
                                color="#ACACAC"
                                readonly
                                no-border
                            >
                                <template #icon-full>
                                    <img :src="URLS.icons.fullReviewStar" alt="star" />
                                </template>
                                <template #icon-empty>
                                    <img :src="URLS.icons.emptyReviewStar" alt="emtpy-star" />
                                </template>
                            </b-form-rating>
                        </div>
                    </div>
                </div>
                <div v-if="screen.isTablet.value" class="feedback-wrapper">
                    <p class="feedback-title">Feedback</p>
                    <p class="feedback-review">{{ review.review }}</p>
                </div>
            </div>
            <div v-if="!screen.isTablet.value" class="event-feedback">
                <div class="general-impression-wrapper">
                    <p class="feedback-title">How did things go?</p>
                    <p class="feedback-value">
                        {{ impressionMapper[review.general_impression] }}
                    </p>
                </div>
                <div v-if="mode === 'Artist'" class="recommendation-wrapper">
                    <p class="feedback-title">
                        Would you recommend this booker to fellow artists?
                    </p>
                    <p class="feedback-value">{{ recommendMapper[review.would_recommend] }}</p>
                </div>
                <div class="feedback-wrapper">
                    <p class="feedback-title">Feedback</p>
                    <p class="feedback-review">{{ review.review }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import useCheckScreen from '@/composables/useCheckScreen.js'

    const URLS = {
        icons: {
            fullReviewStar: '/images/icons/star.svg',
            emptyReviewStar: '/images/icons/star-outline.svg'
        }
    }
    export default {
        name: 'EventFeedbackCards',
        props: {
            users: {
                required: false,
                default: () => [],
                type: Array
            },
            review: {
                required: false,
                default: () => ({}),
                type: Object
            },
            mode: {
                required: true,
                type: String,
                validator: (v) => ['Artist', 'Venue'].includes(v)
            }
        },
        data: () => ({
            reviews: [],
            artistRatingsForVenue: {
                communication: 'Communication',
                reliability: 'Reliability',
                host_vibe: 'Event Vibe',
                crowd_vibe: 'Crowd Vibe',
                overall_vibe: 'Overall Vibe'
            },
            venueRatingsForArtist: {
                stage_presence: 'Stage Presence',
                audience_engagement: 'Audience Engagement',
                communication: 'Communication',
                timeliness: 'Timeliness'
            },
            impressionMapper: {
                0: 'Great!',
                1: 'Fine',
                2: 'Not so Good'
            },
            recommendMapper: {
                0: 'Yes!',
                1: 'Maybe',
                2: 'Probably not'
            }
        }),
        computed: {
            URLS: () => URLS,
            ratingKeys: (self) =>
                self.mode === 'Artist'
                    ? Object.keys(self.artistRatingsForVenue)
                    : Object.keys(self.venueRatingsForArtist),
            ratingVals: (self) =>
                self.mode === 'Artist'
                    ? Object.values(self.artistRatingsForVenue)
                    : Object.values(self.venueRatingsForArtist),
            feedbackCardStyle: (self) =>
                self.screen.isTablet.value ? { background: 'transparent' } : {}
        },
        watch: {
            users: {
                immediate: true,
                handler(users) {
                    if (users.length && !Object.keys(this.review).length)
                        this.parseReviewsForArtist()
                }
            },
            review: {
                immediate: true,
                handler(review) {
                    if (Object.keys(review).length) this.parseReviewForVenue()
                }
            }
        },
        setup() {
            const { isTablet } = useCheckScreen()

            return {
                screen: {
                    isTablet
                }
            }
        },
        methods: {
            parseReviewsForArtist() {
                for (let i = 0; i < this.users.length; i++) {
                    let artist = this.users[i]

                    this.reviews.push({
                        user_name: artist.artist_name,
                        profile_picture: artist.profile_picture,
                        ...artist.review
                    })
                }
            },
            parseReviewForVenue() {
                this.reviews.push({
                    user_name: this.review.venue_name,
                    profile_picture: this.review.venue_picture,
                    ...this.review
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }
    .event-feedback-cards-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        max-width: 1050px;
        gap: 32px;

        .form-control {
            background-color: transparent;
            padding: 0px;
        }

        .user-type,
        .user-name,
        .title,
        .rating-title {
            color: #acacac;
            font-family: Instrument Sans;
            font-size: 26px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.52px;
            max-width: 245px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .user-type {
            font-size: 22px;
        }
        .feedback-title {
            color: #acacac;
            font-family: Instrument Sans;
            font-size: 26px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.52px;
        }

        .event-feedback-card-wrapper {
            border-radius: 15px;
            background: #262626;
            padding: 20px;
            display: flex;
            flex-direction: row;
            gap: 64px;

            .rating-info {
                display: flex;
                flex-direction: column;
                gap: 24px;

                .feedback-wrapper {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;

                    .feedback-review {
                        max-width: 343px;
                        border-radius: 12px;
                        border: 1px solid #646464;
                        display: flex;
                        padding: var(--AL-16, 16px);
                        text-align: left;
                        text-wrap: wrap;
                        min-height: 63px;
                        color: #acacac;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 125%;
                    }
                }
                .info-wrapper {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 12px;

                    .profile-image {
                        width: 66px;
                        height: 66px;
                        border-radius: 12px;
                        object-fit: cover;
                    }
                    .info {
                        display: flex;
                        flex-direction: column;
                        gap: 12px;
                    }
                }
                .rating-wrapper {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    min-width: 330px;

                    .ratings {
                        display: flex;
                        flex-direction: column;
                        gap: 16px;

                        .rating {
                            display: flex;
                            flex-direction: row;
                            max-width: 330px;

                            .rating-title {
                                min-width: 211px;
                                font-size: 16px;
                                font-style: normal;
                                font-weight: 550;
                                line-height: 125%;
                            }
                        }
                    }
                }
            }
            .event-feedback {
                display: flex;
                flex-direction: column;
                gap: 24px;
                width: 632px;

                .feedback-value {
                    display: flex;
                    padding: 5px 40px 9px 40px;
                    justify-content: center;
                    align-items: center;
                    border-radius: 100px;
                    background: #c9cd00;
                    color: black;
                    font-family: Instrument Sans;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 130%;
                    letter-spacing: 0.14px;
                    max-width: 123px;
                    text-wrap: nowrap;
                }

                .general-impression-wrapper,
                .recommendation-wrapper,
                .feedback-wrapper {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }
                .feedback-wrapper {
                    .feedback-review {
                        border-radius: 12px;
                        border: 1px solid #646464;
                        display: flex;
                        padding: var(--AL-16, 16px);
                        text-align: left;
                        text-wrap: wrap;
                        width: 600px;
                        min-height: 63px;
                        color: #acacac;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 125%;
                    }
                }
            }
        }
    }
</style>
